// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.app-header {
  display: flex;
  flex-direction: row;
  padding: 16px;
  position: relative;
  justify-content: space-between;
  box-shadow: 0px 0px 1px rgba(21, 21, 21, 0.1), 0px 2px 8px -1px rgba(21, 21, 21, 0.2);
}
.app-header__content-left {
  display: flex;
}
.app-header__content-right {
  display: flex;
  flex-direction: row;
}
.app-header__logo {
  width: 128px;
}
.app-header.\\--always-shown {
  display: flex;
  flex-direction: row;
  background-color: #fff;
  height: 72px;
  width: 100%;
  box-shadow: 0px 0px 1px rgba(21, 21, 21, 0.1), 0px 2px 8px -1px rgba(21, 21, 21, 0.2);
}
.app-header__phone-button {
  margin: 0 16px;
  padding: 4px;
  display: flex;
  align-self: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #ffbfc3;
}
.app-header__phone-button-icon {
  width: 32px;
  height: 32px;
}
.app-header progress {
  width: 100%;
  appearance: none;
  color: #0c1c2d;
  height: 3px;
  position: absolute;
  bottom: 0;
  left: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.app-header progress::-webkit-progress-bar {
  background-color: #ffbfc3;
}
.app-header progress::-webkit-progress-value {
  background-color: #0c1c2d;
}
.app-header progress::-moz-progress-bar {
  background-color: #0c1c2d;
}
@media (min-width: 950px) {
  .app-header {
    display: none;
  }
  .app-header.\\--always-shown {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/dist/interest/app-header.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,qFAAqF;AACvF;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,qFAAqF;AACvF;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;EAC7B;AACF","sourcesContent":["/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.app-header {\n  display: flex;\n  flex-direction: row;\n  padding: 16px;\n  position: relative;\n  justify-content: space-between;\n  box-shadow: 0px 0px 1px rgba(21, 21, 21, 0.1), 0px 2px 8px -1px rgba(21, 21, 21, 0.2);\n}\n.app-header__content-left {\n  display: flex;\n}\n.app-header__content-right {\n  display: flex;\n  flex-direction: row;\n}\n.app-header__logo {\n  width: 128px;\n}\n.app-header.\\--always-shown {\n  display: flex;\n  flex-direction: row;\n  background-color: #fff;\n  height: 72px;\n  width: 100%;\n  box-shadow: 0px 0px 1px rgba(21, 21, 21, 0.1), 0px 2px 8px -1px rgba(21, 21, 21, 0.2);\n}\n.app-header__phone-button {\n  margin: 0 16px;\n  padding: 4px;\n  display: flex;\n  align-self: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: 1px solid #ffbfc3;\n}\n.app-header__phone-button-icon {\n  width: 32px;\n  height: 32px;\n}\n.app-header progress {\n  width: 100%;\n  appearance: none;\n  color: #0c1c2d;\n  height: 3px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n.app-header progress::-webkit-progress-bar {\n  background-color: #ffbfc3;\n}\n.app-header progress::-webkit-progress-value {\n  background-color: #0c1c2d;\n}\n.app-header progress::-moz-progress-bar {\n  background-color: #0c1c2d;\n}\n\n@media (min-width: 950px) {\n  .app-header {\n    display: none;\n  }\n  .app-header.\\--always-shown {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
